import { v4 as uuidv4 } from 'uuid';

import { IKnmRequirementsNpa248 } from 'APIPackage/KnmModule/interfaces/IKnmRequirementsNpa248';
import { createMandatoryCategorySelectOption } from 'CorePackage/CatalogsModule/common/createMandatoryCategorySelectOption';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { convertKnmDataViolationsToFormValues } from 'KnmErknmPackage/MainModule/common/convertKnmDataViolationsToFormValues';
import { IKnmErknmFormViolatedRequirementsNpa } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';

export const convertViolationDataToKnmErknmFormViolatedRequirementsNpa = (
  violation: IKnmRequirementsNpa248[] | undefined,
): IKnmErknmFormViolatedRequirementsNpa[] | undefined => {
  return violation?.map<IKnmErknmFormViolatedRequirementsNpa>(item => ({
    guid: uuidv4(),
    npa: {
      id: item.npaId,
      number: item.number || undefined,
      acceptanceDate: formatDate({
        date: item.acceptanceDate ?? '',
        dateFormat: DATE_FORMAT_LONG_FNS,
        parseFormat: SYSTEM_DATE_FORMAT_FNS,
      }),
      title: item.title || undefined,
    },
    structuralUnit: {
      id: item.structuralUnit.id,
      title: item.structuralUnit.title || undefined,
    },
    violatedMandatory: item.structuralUnit.mandatoryRequirements
      ? item.structuralUnit.mandatoryRequirements.map(mandatory => ({
          mandatory: {
            id: mandatory.id,
            title: mandatory.title || '',
          },
          category: mandatory.category ? createMandatoryCategorySelectOption(mandatory.category) : undefined,
          violations: mandatory.violations?.length
            ? convertKnmDataViolationsToFormValues(mandatory.violations, true)
            : null,
        }))
      : [],
    inspectionResults: item.inspectionResults,
  }));
};
